function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Grid } from '@signicat/designi/components/layout';
import { Icon } from '@signicat/designi/components/icons';
import { Label } from '@signicat/designi/components/forms';
import { Segment } from '@signicat/designi/components/containers';
import { Div } from '@signicat/designi/components/layout';
import { HelpText } from '@signicat/designi/components/text';
import { TextField } from '@signicat/designi/components/inputs';
import { Form, Field } from '@signicat/designi/components/forms';
import { t } from "../../../helpers/i18n";
import { Feature } from '@signiapp/core/components';
var SmsSender = function SmsSender(props) {
  var smsSender = props.smsSender,
    disabled = props.disabled;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    customSMSNotificationEnabled = _useState2[0],
    setCustomSMSNotificationEnabled = _useState2[1];
  var handleSmsSenderChange = function handleSmsSenderChange(e) {
    props.setSmsSender(e.target.value);
  };
  return /*#__PURE__*/React.createElement(Div, null, /*#__PURE__*/React.createElement(Feature, {
    featureId: "signature_custom_smsnotification",
    onFeatureToggle: function onFeatureToggle(e) {
      return setCustomSMSNotificationEnabled(e);
    }
  }, /*#__PURE__*/React.createElement(Segment, {
    divided: true,
    outlined: true,
    direction: "column",
    marginBottom: "32px"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "row"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 2,
    direction: "row",
    alignItems: "stretch"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      flex: '0 0 auto',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "language",
    style: {
      paddingLeft: '4px',
      paddingTop: '12px'
    }
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      flex: '1 0 0'
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Label, null, t('module_settings_sms_sender_label')), /*#__PURE__*/React.createElement(HelpText, {
    style: {
      marginTop: '2px'
    }
  }, t('module_settings_sms_sender_helptext')))))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Field, {
    name: "smsSender"
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    label: t('module_settings_sms_sender_label'),
    onChange: handleSmsSenderChange,
    value: smsSender || '',
    name: "smsSender",
    inputProps: {
      maxLength: 11
    },
    disabled: disabled || !customSMSNotificationEnabled
  }))))))));
};
export default SmsSender;